/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import clsx from 'clsx'
import React from 'react'
import { Icon } from '../../utils/Icon'
import { VStack } from './VStack'
import { Horizon } from '../map_facilities/Horizon'
import { CardSection, Heading } from './CardSection'
import { FacilityMedicalInstitutionType } from '../../entites/FacilityInfo'

export type Clinic = {
  name: string
  siteUrl: string
}

export type ClinicsProps = {
  medicalInstitutionType: FacilityMedicalInstitutionType
  attached?: Clinic
  collaboratives?: Clinic[]
}

export const Clinics = ({
  attached,
  collaboratives,
  medicalInstitutionType,
}: ClinicsProps) => {
  const BottomText = () => {
    if (medicalInstitutionType == 'any_medical_institution') {
      if (attached && attached.name && attached.name !== '') {
        return (
          <p>
            ※指定医療機関<strong>以外</strong>の受診でも利用できます。
          </p>
        )
      } else {
        return (
          <p>
            医療機関の指定はありません。
            <br />
            かかりつけ医療機関などで受診してください。
          </p>
        )
      }
    } else {
      return <p>※利用には、指定医療機関の受診が必要です。</p>
    }
  }

  return (
    <CardSection id="clinics">
      <Heading>指定医療機関</Heading>
      <VStack gap="15px">
        {attached && attached.name && attached.name.length > 0 && (
          <ClinicRow
            name={attached.name}
            isAttached={true}
            href={attached.siteUrl}
          />
        )}
        {medicalInstitutionType == 'specified_medical_institution' &&
          collaboratives &&
          collaboratives
            .filter((clinic) => clinic.name && clinic.name.length > 0)
            .map((clinic, i) => (
              <React.Fragment key={`${i}_${clinic.name}`}>
                <ClinicRow
                  name={clinic.name}
                  isAttached={false}
                  href={clinic.siteUrl}
                />
              </React.Fragment>
            ))}
        <BottomText />
      </VStack>
    </CardSection>
  )
}

type ClinicRowProps = {
  name: string
  isAttached: boolean
  href: string
}

const ClinicRow = ({ name, isAttached, href }: ClinicRowProps) => {
  return (
    <Horizon columnGaps={[5, 8]} css={clinicRowStyle}>
      <a className="link" href={href} target="_blank" rel="noopener noreferrer">
        {name}
      </a>
      {isAttached && (
        <span className={'chip attached'}>
          <span className="label">併設</span>
        </span>
      )}
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Icon
          iconName="blank"
          style={{
            width: '14px',
            height: '14px',
          }}
        />
      </a>
    </Horizon>
  )
}

const clinicRowStyle = css`
  .link {
    font-size: 14px;
    line-height: 160%;
    text-decoration-line: underline;

    &:visited,
    &:link {
      color: inherit;
    }
  }
  .chip {
    position: relative;
    display: flex;
    align-items: center;
    padding: 4px 5px;
    width: 36px;
    height: 20px;
    border: 1px solid #3f3d35;
    border-radius: 4px;

    .label {
      font-size: 12px;
      line-height: 12px;
      white-space: nowrap;
    }

    &.attached {
      border-color: #0a9600;

      .label {
        color: #0a9600;
      }
    }
  }
`
